<template>
<div class="vliveEdit padding-20 bgc box-shadow">
    <div class="form">
        <el-form :model="item" :rules="rules" ref="formName" label-width="120px" class="demo-item" label-position="left" size="mini">
            <div class="classes blod">直播控制台</div>
            <el-form-item label="直播类型" prop="liveType" class="liveName">
                <el-radio :disabled="liveTypeDisabled" v-model="item.liveType" :label="1">视频直播</el-radio>
                <el-radio :disabled="liveTypeDisabled" v-model="item.liveType" :label="2">图文直播</el-radio>
            </el-form-item>
            <el-form-item v-if="item.liveType === 1" label="是否录播" class="liveName">
                <el-switch v-model="item.isrecord" :disabled="isDisabled"></el-switch>
            </el-form-item>
            <el-form-item label="直播名称" prop="subject" class="liveName">
                <el-input style="width: 500px;" v-model="item.subject" :disabled="isDisabled" maxlength="50" show-word-limit clearable placeholder="2-50个字"></el-input>
            </el-form-item>
            <el-form-item label="直播封面" prop="logoPic" class="upload-image">
                <upload class="headImage" :imgRule="imgRule" ref="logofile" @setImage="setLogourl" :uploadType="uploadType" v-if="!isDisabled"></upload>
                <div class="upload headImage" v-else>
                    <div class="avatar-uploader">
                        <div tabindex="0" class="el-upload el-upload--text" style="cursor: not-allowed;">
                            <img :src="item.logourl" class="avatar">
                        </div>
                    </div>
                </div>
                <div class="el-upload__tip">
                    <el-button type="warning" @click="openCoverScrollBox" :disabled="isDisabled">素材库</el-button>
                    <div>建议像素：1280（宽）*720（高），JPG、PNG格式，大小不超过5M。 </div>
                </div>
            </el-form-item>
            <el-form-item label="直播简介" class="liveName">
                <el-input type="textarea" v-model="item.description" :disabled="isDisabled" maxlength="200" show-word-limit ></el-input>
            </el-form-item>
            <el-form-item label="开始时间" prop="begintime">
                <el-date-picker v-model="item.begintime" type="datetime" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" :disabled="liveTimeDisabled" clearable></el-date-picker>
            </el-form-item>
            <el-form-item label="直播详情" v-if="item.liveType === 1">
                <uEditor :content="item.content" ref="uEditor" @getUEditorContent="getMsgContent"></uEditor>
            </el-form-item>
            <!-- <el-form-item label="商品分组" class="commodityGroup" v-if="domain === 1"> -->
            <el-form-item label="商品分组" class="commodityGroup">
                <el-select v-model="item.divisionids" multiple placeholder="请选择" collapse-tags clearable>
                    <el-option v-for="item in shopGroupList" :key="item.innerid" :label="item.name" :value="item.innerid"> </el-option>
                </el-select>
                <el-button type="text" size="small" @click="_getShopGroupList">刷新</el-button>
                <el-button type="text" size="small" @click="goGoodsGroup">前往商品分组</el-button>
                <p class="groupTips">商品分组可辅助你更好地管理商品</p>
            </el-form-item>
            <div class="classes blod" v-if="item.liveType === 1">付费设置</div>
            <el-form-item label="付费方式" class="pay_way_box" v-if="item.liveType === 1">
                <div class="pay_box">
                    <el-radio-group v-model="item.feetype" :disabled="!iscanchangefeetype">
                        <el-radio :label="1">免费</el-radio>
                        <el-radio :label="2">付费</el-radio>
                        <el-radio :label="3">加密</el-radio>
                    </el-radio-group>
                    <div class="type" v-if="item.feetype === 2">
                        <el-form-item label="商品价格" prop="saleprice">
                            <el-input v-model="item.saleprice" placeholder="请输入商品价格"></el-input>
                            元
                        </el-form-item>
                        <el-form-item label="划线价格" class="not_margin_bottom">
                            <el-input v-model="item.uprice" placeholder="请输入划线价格"></el-input>
                            元
                        </el-form-item>
                    </div>
                    <div class="type" v-if="item.feetype === 3">
                        <el-form-item label="设置密码" prop="livepass" class="not_margin_bottom">
                            <el-input v-model="item.livepass" placeholder="设置密码"></el-input>
                        </el-form-item>
                    </div>
                </div>
            </el-form-item>
            <div class="classes blod" v-if="item.liveType === 1">其他设置</div>
            <el-form-item label="是否评论" class="iscomment_box" v-if="item.liveType === 1">
                <el-radio-group v-model="item.isopencomment">
                    <el-radio :label="1">开启</el-radio>
                    <el-radio :label="0">关闭</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="直播标签" class="live_label" v-if="item.liveType === 1">
                <div class="create_box">
                    <el-select @visible-change="visibleChange" :popper-append-to-body="false" v-model="item.tags" multiple filterable allow-create default-first-option placeholder="按回车键创建标签" :multiple-limit="10"></el-select>
                    <div class="tips" :class="{'active': labelFocus}">还可以创建{{10 - item.tags.length}}个标签</div>
                </div>
                <!-- <el-input placeholder="按回车键创建标签" v-model="item.label" @keyup.enter.native="createLabel">
                    <template slot="append">还可以创建10个标签</template>
                </el-input> -->
                <div class="tags_box">
                    <div class="name">推荐标签：</div>
                    <div class="item" @click="clickRecommend(item)" v-for="(item, index) in recommendTags" :key="index">{{item}}</div>
                </div>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="submitForm" :disabled="isDisabled">提交</el-button>
                <el-button style="margin-left: 30px;" type="" @click="cancel">取消</el-button>
            </el-form-item>
        </el-form>
    </div>
    <scrollBox ref="coverScrollBox" :uploadType="uploadType" @saveMaterialFile="setMaterialCoverfile"></scrollBox>
</div>
</template>

<script>
import Upload from 'base/upload/upload'
import {mapGetters, mapActions} from 'vuex'
import {editVlive, getVliveView, addVlive, saveAndupdateLive, getLiveInfo, getShopGroupList} from 'api/api'
import {formatFileInfo} from 'common/js/tools'
import ScrollBox from 'base/scrollBox/scrollBox'
import $ from 'jquery'
import {vliveMsg} from 'api/message'
import UEditor from 'base/uEditor/uEditor'
export default {
    name: 'vliveEdit',
    data() {
        let validateCoverPicture = (rule, value, callback) => {
            if (!value.furl) {
                callback(new Error('请选择视频封面'))
            } else {
                callback()
            }
        }
        let validateBegintime = (rule, value, callback) => {
            if (this.user.isofficalhost==1){
                callback()
            }
            else{
                let flag = (new Date(value) <= new Date())
                if (!this.item.innerid && flag) {
                    callback(new Error(vliveMsg.vliveBegintime.msg))
                } else {
                    callback()
                }
            }
        }
        return {
            liveTimeDisabled: false,
            liveTypeDisabled: false,
            isDisabled: true,
            uploadType: {
                catecode: '95',
                datatype: 'IMAGE'
            },
            shopGroupList: [], // 商品分组
            item: {
                innerid: this.$route.query.id ? this.$route.query.id : '', // id
                liveType: 1, // 直播类型 1：视频直播    2：图文直播
                subject: '',
                isrecord: 0,
                logoPic: {
                    bucket: '',
                    fname: '',
                    fsize: '',
                    width: '',
                    height: '',
                    key: '',
                    mimeType: '',
                    objecttype: '',
                    furl: ''
                },
                description: '',
                begintime: '',
                despfee: '',
                feetype: 1,
                saleprice: '',
                uprice: '',
                livepass: '',
                isopencomment: 1,
                tags: [],
                content: '',
                divisionids: []
            },
            iscanchangefeetype: true,
            recommendTags: [
                '商业',
                '财经',
                '经济',
                '投资',
                '半导体',
                '汽车',
                '芯片',
                '原创',
                '互联网',
                '金融',
                '科技',
                '股市',
                '技术',
                'GDP',
                '企业',
                '上市',
                '智能制造',
                '智能科技',
                '创新'
            ],
            rules: {
                liveType: [
                    {required: true, message: '请选择直播类型', trigger: 'blur'},
                ],
                subject: [
                    {required: true, message: '请输入直播名称', trigger: 'blur'},
                    {min: 2, max: 50, message: '长度在2到50个字', trigger: 'blur'}
                ],
                logoPic: [
                    {required: true, message: '请选择直播封面', trigger: 'blur'},
                    {validator: validateCoverPicture, trigger: 'blur'}
                ],
                begintime: [
                    {required: true, message: '请选择开始时间', trigger: 'blur'},
                    {validator: validateBegintime, trigger: 'blur'}
                ],
                feetype: [
                    {required: true, message: '请选择开始时间', trigger: 'blur'}
                ],
                saleprice: [
                    {required: true, message: '请输入商品价格', trigger: 'blur'}
                ],
                livepass: [
                    {required: true, message: '请输入密码', trigger: 'blur'}
                ]
            },
            imgRule: {
                cls: 'icon_upload',
                accept: 'image/png,image/jpeg',
                size: 5,
                width: '',
                height: ''
            },
            labelFocus: false
        }
    },
    mounted() {
        // 获取商品分组
        this._getShopGroupList()
        // 发布设置直播开始时间默认提前10分钟
        this.getTime()
        this.isDisabled = false
        if (this.item.innerid) {
            this.liveTypeDisabled = true
            // this.item.liveType = parseInt(this.$route.query.type)
            if (parseInt(this.$route.query.type) === 1) {
                this._getView()
            } else {
                this._getView2()
            }
        }
    },
    methods: {
        _getShopGroupList () {
            getShopGroupList({
                data: {},
                success: data => {
                    this.shopGroupList = data.data
                    this.setLoading(false)
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        // 前往商品分组
        goGoodsGroup() {
            let goPath = window.location.origin + '/shopMgt/goods/goodsGroup'
            window.open(goPath)
        },
        visibleChange(e) {
            if (e) {
                this.labelFocus = true
            } else {
                this.labelFocus = false
            }
        },
        clickRecommend(item) {
            if (this.item.tags.length < 10) {
                if (this.item.tags.indexOf(item) === -1) {
                    this.item.tags.push(item)
                }
            } else {
                this.$message.warning('最多只能有10个标签哦')
            }
        },
        getMsgContent(content) {
            this.item.content = content
        },
        getTime() {
            var d=new Date()
            var min=d.getMinutes() // 获取分钟
            d.setMinutes(min+10)
            var year=d.getFullYear()
            var month=change(d.getMonth()+1)
            var day=change(d.getDate())
            var hour=change(d.getHours())
            var minute=change(d.getMinutes())
            var second=change(d.getSeconds())
            function change(t){
                if(t<10){
                    return "0"+t
                }else{
                    return t
                }
            }
            var time = year+'-'+month+'-'+day+' '+hour+':'+minute+':'+second
            this.item.begintime = time
            // console.log(time)
        },
        // 打开图片素材库选择框（封面）
        openCoverScrollBox() {
            this.$refs.coverScrollBox.openDialog()
        },
        // 设置素材库选择的图片信息（封面）
        setMaterialCoverfile(file) {
            this.item.logoPic = file
            this.$refs.logofile.setImage(this.item.logoPic.furl)
        },
        setLogourl(file) {
            this.item.logoPic = file
        },
        cancel() {
            if (this.isDisabled) {
                this.$router.back()
            } else {
                this.$confirm(vliveMsg.cancelEdit.msg, vliveMsg.cancelEdit.title, {
                    confirmButtonText: vliveMsg.cancelEdit.confirmText,
                    cancelButtonText: vliveMsg.cancelEdit.cancelText
                }).then(() => {
                    this.$router.back()
                }).catch(() => {})
            }
        },
        submitForm() {
            this.$refs.formName.validate((valid) => {
                if (valid) {
                    let flag = (new Date(this.item.begintime) <= new Date())
                    if (!this.item.innerid && flag && this.user.isofficalhost != 1) {
                        this.$alert(vliveMsg.vliveBegintime.msg, vliveMsg.vliveBegintime.title, {
                            dangerouslyUseHTMLString: true
                        })
                    } else {
                        this.$confirm(vliveMsg.submitEdit.msg, vliveMsg.submitEdit.title, {
                            confirmButtonText: vliveMsg.submitEdit.confirmText,
                            cancelButtonText: vliveMsg.submitEdit.cancelText
                        }).then(() => {
                            let obj = $.extend(true, {}, Object.assign({}, this.item))
                            obj.logoPic = formatFileInfo(obj.logoPic)
                            // console.log(obj)
                            if (obj.liveType === 1) {
                                obj.tags = obj.tags.join(',')
                            }
                            // console.log('obj:', obj)
                            if (obj.isrecord) {
                                obj.isrecord = 1
                            } else {
                                obj.isrecord = 0
                            }
                            if (obj.liveType === 2) {
                                obj.isrecord = 0
                            }
                            obj.divisionids = obj.divisionids.join(',')
                            // console.log('obj:', obj)
                            if (obj.innerid) {
                                if (obj.liveType === 1) {
                                    
                                    this._editObject(obj)
                                } else {
                                    this.saveAndupdateLiveFn(obj)
                                }
                            } else {
                                if (obj.liveType === 1) {
                                    this._addObject(obj)
                                } else {
                                    this.saveAndupdateLiveFn(obj)
                                }
                            }
                        }).catch()
                    }
                }
            })
        },
        // 新增 编辑图文直播
        saveAndupdateLiveFn(obj) {
            this.setLoading(true)
            saveAndupdateLive({
                data: Object.assign({}, obj),
                success: data => {
                    this.$message.success(vliveMsg.submitEdit.successMsg)
                    this.setLoading(false)
                    this.setPage({page: 1, pageSize: 10})
                    this.$router.back()
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        // 新增发布视频直播
        _addObject(obj) {
            this.setLoading(true)
            addVlive({
                data: Object.assign({}, obj),
                success: data => {
                    if (data.isauth === 0) {
                        this.$message.success('您的直播已发布成功！')
                    } else {
                        this.$message.success('您的直播已发布完成，等待审核！')
                    }
                    // this.$message.success(vliveMsg.submitEdit.successMsg)
                    this.setLoading(false)
                    this.setPage({page: 1, pageSize: 10})
                    this.$router.back()
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        // 修改编辑视频直播
        _editObject(obj) {
            this.setLoading(true)
            editVlive({
                data: Object.assign({}, obj),
                success: data => {
                    this.$message.success(vliveMsg.submitEdit.successMsg)
                    this.setLoading(false)
                    this.$router.back()
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        _getView() {
            this.setLoading(true)
            getVliveView({
                data: {
                    innerid: this.item.innerid
                },
                success: data => {
                    data.data.tags = data.data.tags ? data.data.tags.split(',') : []
                    data.data.divisioninnerid = JSON.parse(data.data.divisioninnerid)
                    data.data.divisionids = JSON.parse(JSON.stringify(data.data.divisioninnerid))
                    delete data.data.divisioninnerid
                    this.item = data.data
                    this.item.liveType = parseInt(this.$route.query.type)
                    if (this.item.isrecord === 1) {
                        this.item.isrecord = true
                    } else {
                        this.item.isrecord = false
                    }
                    if (this.item.status === 30) {
                        this.iscanchangefeetype = false
                    }
                    if (this.item.liveType === 1) {
                        this.$refs.uEditor.init(this.item.content)
                    }
                    // 控制直播开始之后 是否可以编辑
                    // let time = new Date(this.item.begintime)
                    // this.isDisabled = time <= new Date()
                    // console.log('视频data.data:', data.data);
                    if (!(data.data.status === 0)) {
                        this.liveTimeDisabled = true
                    }
                    this.$nextTick(() => {
                        if (!this.isDisabled) {
                            this.$refs.logofile.setImage(this.item.logoPic.furl)
                        }
                    })
                    this.setLoading(false)
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        _getView2() {
            this.setLoading(true)
            getLiveInfo({
                data: {
                    innerid: this.item.innerid
                },
                success: data => {
                    // data.data.divisioninnerid = JSON.parse(data.data.divisioninnerid)
                    // data.data.divisionids = JSON.parse(JSON.stringify(data.data.divisioninnerid))
                    // delete data.data.divisioninnerid
                    this.item = data.data
                    this.item.liveType = parseInt(this.$route.query.type)
                    // 控制直播开始之后 是否可以编辑
                    // let time = new Date(this.item.begintime)
                    // this.isDisabled = time <= new Date()

                    // console.log('图文data.data:', data.data);
                    if (!(data.data.status === 0)) {
                        this.liveTimeDisabled = true
                    }
                    this.$nextTick(() => {
                        if (!this.isDisabled) {
                            this.$refs.logofile.setImage(this.item.logoPic.furl)
                        }
                    })
                    this.setLoading(false)
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        ...mapActions([
            'setLoading',
            'setPage'
        ]),
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters([
            'loading',
            'user',
            'domain'
        ])
    },
    components: {
        Upload,
        ScrollBox,
        UEditor
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
@import "~common/scss/variable";
@import "~common/scss/mixin";
.vliveEdit {
    .form{
        margin-top: 0;
    }
    .upload-file{
        width: 800px;
    }
    .headImage .avatar-uploader{
        box-sizing: border-box;
        width: 320px;
        height: 180px;
    }
    .el-upload__tip{
        color: $tcolor-lightgrey;
        align-self: flex-end;
        margin-left: 20px;
        flex-grow: 1;
    }
    .el-date-editor--date{
        margin-right: 30px;
    }
    .liveName,.upload-image{
        .el-form-item__content{
            width: 805px;
            @include flexBox(flex-start);
        }
    }
    .el-collapse-item__wrap,.el-collapse,.el-collapse-item__header{
        border-width: 0;
    }
    .el-collapse-item__arrow{
        margin: 0 5px;
    }
    .el-collapse-item__header{
        color: $tcolor-blue;
    }
    .el-radio{
        margin-top: 10px;
    }
    .pay_way_box {
        .el-form-item__label {
            padding-top: 14px;
        }
        .pay_box {
            padding: 14px 20px;
            background: #F6F7FA;
            width: 712px;
            box-sizing: border-box;
            .el-radio {
                margin-top: 0;
            }
            // .el-radio-group {
            //     margin-bottom: 12px;
            // }
            .type {
                margin-top: 12px;
                .el-form-item__label {
                    padding: 0;
                    width: 80px !important;
                }
                .el-form-item__content {
                    margin-left: 80px !important;
                }
                .not_margin_bottom {
                    margin-bottom: 0;
                }
            }
            .el-input {
                width: 230px;
                margin-right: 12px;
            }
        }
    }
    .iscomment_box {
        .el-radio-group {
            padding-left: 20px;
            .el-radio {
                margin-top: 0;
            }
        }
    }
    .live_label {
        .create_box {
            display: flex;
            align-items: stretch;
            width: 712px;
            margin-bottom: 10px;
            &:hover {
                .tips {
                    border-color: #C0C4CC;
                }
                .tips.active {
                    border-color: #409EFF;
                }
            }
            .tips {
                // align-items: stretch;
                // height: 100%;
                border: 1px solid #DCDFE6;
                border-left: none;
                display: flex;
                align-items: center;
                justify-content: center;
                box-sizing: border-box;
                padding: 0 10px;
                border-radius: 0 4px 4px 0;
                font-size: 14px;
                color: #606266;
                transition: border-color .2s cubic-bezier(.645,.045,.355,1);
                &.active {
                    border-color: #409EFF;
                }
            }
        }
        .el-select {
            width: 538px;
            // margin-bottom: 10px;
            .el-input {
                height: auto;
            }
            .el-input__inner {
                border-right: none;
                border-radius: 4px 0 0 4px;
            }
            .el-input-group__append {
                background: #fff;
                border-color: #DCDFE6 #DCDFE6 #DCDFE6 #fff;
                color: #606266;
                padding: 0 10px;
            }
            .el-select-dropdown__empty, .el-select-dropdown, .el-input__suffix {
                display: none;
            }
        }
        .tags_box {
            display: flex;
            flex-wrap: wrap;
            width: 712px;
            align-items: center;
            .name {
                font-size: 14px;
                margin-bottom: 10px;
            }
            .item {
                height: 24px;
                box-sizing: border-box;
                padding: 0 15px;
                line-height: 24px;
                border: 1px solid #CCCCCC;
                border-radius: 14px;
                font-size: 12px;
                color: #666666;
                margin: 0 10px 10px 0;
                cursor: pointer;
            }
        }
    }
    .shopGroup{
        .el-select{
            width: 368px;
        }
        .el-button{
            min-width: 0;
            margin-right: 24px;
        }
        .refresh{
            margin-left: 18px;
        }
    }
    .commodityGroup{
        .el-select{
            width: 368px;
        }
        .el-button{
            min-width: 0;
            margin: 0 10px;
        }
        .groupTips{
            color: #909399;
        }
    }
}
</style>
